import { buildSuggestionMarker, parseSuggestionMarker } from './suggestionMarkers';

let pendingSuggestionKey: string | null = null;

/** Remember suggestion key for compose-mode (marker not shown in textarea). */
export function setPendingSuggestionKey(key: string | null): void {
  pendingSuggestionKey = key?.trim() || null;
}

export function getPendingSuggestionKey(): string | null {
  return pendingSuggestionKey;
}

export function consumePendingSuggestionKey(): string | null {
  const key = pendingSuggestionKey;
  pendingSuggestionKey = null;
  return key;
}

/** Ensure the outbound user text carries the suggestion marker when needed. */
export function attachPendingSuggestionMarker(text: string): string {
  if (!text.trim()) return text;
  if (parseSuggestionMarker(text)) {
    consumePendingSuggestionKey();
    return text;
  }
  const key = consumePendingSuggestionKey();
  if (!key) return text;
  return `${text.trim()}\n${buildSuggestionMarker(key)}`;
}
